import { vars } from "@common/styles";
import styled from "styled-components";

export const AttachmentButtonsContainer = styled.div`
  position: absolute;
  right: 2rem;
  top: 0.8rem;
  border: 1px solid ${vars.colors.grey80};
  border-radius: 0.6rem;
  display: flex;
  background-color: ${vars.colors.grey90};
  flex-direction: row;
  padding: 0.3rem;
`;

export const AttachmentButton = styled.a`
  height: 3.8rem;
  width: 3.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 0.4rem;

  path {
    stroke: #f2f2f7;
  }

  :hover {
    background-color: ${vars.colors.grey80};
  }
`;
